/** The operation an auth event belongs to, as known when it is sent: what the system did, not which button was pressed. */
export type AuthUseCase = 'sign_in' | 'sign_up' | 'unknown';

export const UNCLASSIFIED_AUTH_FAILURE = 'unclassified';

export interface AuthFailure {
    /** Stable code: the resource key the failure named, else a client classification, else `unclassified`. */
    reason: string;
    /** Technical detail — stage, HTTP status, raw text of a failure that named no key — masked; never user-facing wording. */
    detail?: string;
    useCase: AuthUseCase;
}
